import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-637de67f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-alert" }
const _hoisted_2 = { class: "modal-alert-inner" }
const _hoisted_3 = { class: "item-title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "We will be in contact soon...", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, {
    onBeforeEnter: _ctx.modalBeforeEnter,
    onEnter: _ctx.modalEnter,
    onLeave: _ctx.modalLeave
  }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _createVNode(_Transition, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h4", _hoisted_3, [
                _renderSlot(_ctx.$slots, "default", {}, undefined, true)
              ]),
              _hoisted_4,
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeModal'))),
                class: "button btn-send"
              }, "Close")
            ])
          ]),
          _: 3
        })
      ], 512), [
        [_vShow, _ctx.modalActive]
      ])
    ]),
    _: 3
  }, 8, ["onBeforeEnter", "onEnter", "onLeave"]))
}